import React from 'react'
import { logEvent } from '@/lib/gtm'
import { mq } from '@/styles/size'

interface Props {
  bgColor: string
  image: {
    src: string
    alt?: string
  }
  href: string
  action: string
  isScrap: boolean
}

function Product({
  bgColor,
  image,
  href,
  action,
  isScrap,
}: Props): React.ReactElement {
  return (
    <div
      css={mq({
        gridColumn: [
          'span 1',
          'span 1',
          'span 1',
          isScrap ? '2/span 2' : 'span 2',
        ],
      })}
    >
      <div
        css={{
          margin: '0 auto',
          maxWidth: '540px',
        }}
      >
        <figure
          css={{
            width: '100%',
            position: 'relative',
            paddingTop: `${(160 / 540) * 100}%`,
            height: 0,
          }}
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={href}
            onClick={() =>
              logEvent({
                category: 'Other Product',
                action,
              })
            }
            css={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              borderRadius: '24px',
              textDecoration: 'none !important',
              color: 'white',
              justifyContent: 'flex-start !important',
              textShadow: '0 0 8px rgba(42, 42, 42, 0.8)',
              transition: 'all 350ms',
              '&:hover': {
                boxShadow: `8px 8px ${bgColor}`,
              },
            }}
          >
            <img
              src={image.src}
              alt={image.alt}
              css={{ width: '100%', height: '100%' }}
            />
          </a>
        </figure>
      </div>
    </div>
  )
}

export default Product
